module.exports = __webpack_public_path__ + "static/media/insurance_item-08.b2b2173c.svg";